module.exports = __webpack_public_path__ + "img/affiliate-settings.41651b04.svg";